import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { CustomerToDelete } from 'shared/types';

export function useCreateCustomerToDelete() {
  const { customerService } = useService();

  const mutation = useMutation<void, Error, CustomerToDelete>(
    (customer: CustomerToDelete) => {
      return customerService.createNewCustomerToDelete(customer);
    },
    {
      onSuccess: () => {},
    }
  );

  return mutation;
}
